import type { GoogleProfile } from '../../../src/shared/types';
import { isGoogleCalendarConnected } from './googleAuth';

/**
 * `tokenStore.ts`'nin web karşılığı. Masaüstünde Google oturumu cihazda
 * şifreli bir dosya; web'de takvim yetkisi sunucuda. "Oturum var mı" sorusu
 * sunucudaki takvim bağlantısına soruluyor, yazma işlemleri boş.
 */

export async function saveSession(): Promise<void> {}

export async function loadSession(): Promise<null> {
  return null;
}

export async function updateProfile(_profile: GoogleProfile): Promise<void> {}

export async function clearSession(): Promise<void> {}

export async function hasSession(): Promise<boolean> {
  return isGoogleCalendarConnected();
}
